import { html, render } from 'lit-html';
import { appStore } from '../store/appStore.js';
import './LoadingSpinner.js';

export class LoadingOverlay extends HTMLElement {
  private unsubscribe?: () => void;

  connectedCallback() {
    this.unsubscribe = appStore.subscribe(() => {
      this.render();
    });
    this.render();
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  private render() {
    const state = appStore.getState();
    const { isLoading } = state;
    const message = this.getAttribute('message') || 'Loading...';

    if (!isLoading) {
      render(html``, this);
      return;
    }

    const template = html`
      <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white rounded-lg p-6 shadow-lg">
          <loading-spinner size="lg" color="blue" text="${message}"></loading-spinner>
        </div>
      </div>
    `;

    render(template, this);
  }
}

// Register the custom element
customElements.define('loading-overlay', LoadingOverlay);
